module.exports = "pegasus/assets/themelp1/small/22.png";